import { render, staticRenderFns } from "./RulesetGuide.vue?vue&type=template&id=39abdea0&scoped=true&"
import script from "./RulesetGuide.vue?vue&type=script&lang=js&"
export * from "./RulesetGuide.vue?vue&type=script&lang=js&"
import style0 from "./RulesetGuide.vue?vue&type=style&index=0&id=39abdea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39abdea0",
  null
  
)

export default component.exports